import { StyledBulletPointsList, StyledDiv, StyledText } from './HowItWorksOnboarding.styles';
import { howItWorksPageContent } from './HowItWorksOnboarding.copy';

const { howItWorks } = howItWorksPageContent;

const HowItWorksOnboarding = () => (
  <StyledDiv>
    <StyledBulletPointsList content={howItWorks.content} color="light" />
    <StyledText variant="body1">Find all the details on our FAQ page</StyledText>
  </StyledDiv>
);

export default HowItWorksOnboarding;
